import { useEffect, useState } from "react";

const themeStorageKey = "tablerTheme";
const defaultTheme = "light";

export function useTheme() {
  const [theme, setTheme] = useState(() => {
    const storedTheme = localStorage.getItem(themeStorageKey);
    return storedTheme || defaultTheme;
  });

  useEffect(() => {
    if (theme === "dark") {
      document.body.setAttribute("data-bs-theme", "dark");
    } else {
      document.body.removeAttribute("data-bs-theme");
    }
    localStorage.setItem(themeStorageKey, theme);
  }, [theme]);

  return { theme, setTheme };
}
